import * as React from 'react';
import styled from 'styled-components';
import { ScrollableArea } from '../../layout/ScrollableArea';

// TODO: delete either scrollable or notScrollable prop when proper method is decided
interface IProps {
  children: React.ReactNode;
  withoutFooter?: boolean;
  style?: React.CSSProperties;
  notScrollable?: boolean;
  className?: string;
  id?: string;
  role?: string;
}

export const CardBody = (props: IProps): React.ReactElement => {
  return (
    <Container
      id={props.id}
      withoutFooter={props.withoutFooter}
      style={props.style}
      className={props.className}
      role={props.role}
    >
      {props.notScrollable ? (
        props.children
      ) : (
        <ScrollableArea>{props.children}</ScrollableArea>
      )}
    </Container>
  );
};

const Container = styled.div<{
  withoutFooter?: boolean;
  scrollable?: boolean;
}>`
  border-bottom-left-radius: ${(props: { withoutFooter?: boolean }): string =>
    props.withoutFooter ? '10px' : '0px'};
  border-bottom-right-radius: ${(props: { withoutFooter?: boolean }): string =>
    props.withoutFooter ? '10px' : '0px'};
  height: auto;
  min-height: 0px;
  width: 100%;
  display: flex;
  flex-direction: column;
  flex: 1;
`;
